import { Modules } from '@kaetram/common/network';

interface EffectInfo {
    name: string;
    cssClass: string;
    debuff?: boolean;
}

const EFFECT_MAP: { [K in Modules.Effects]?: EffectInfo } = {
    [Modules.Effects.ThickSkin]: { name: 'Piel Gruesa', cssClass: 'thickskin' },
    [Modules.Effects.Running]: { name: 'Correr', cssClass: 'run' },
    [Modules.Effects.DualistsMark]: { name: 'Marca Dualista', cssClass: 'dualistsmark' },
    [Modules.Effects.HotSauce]: { name: 'Salsa Picante', cssClass: 'hotshot' },
    [Modules.Effects.Invincible]: { name: 'Invencible', cssClass: 'buff-invincible' },
    [Modules.Effects.SnowPotion]: { name: 'Poción Nieve', cssClass: 'buff-snow' },
    [Modules.Effects.FirePotion]: { name: 'Poción Fuego', cssClass: 'buff-fire' },
    [Modules.Effects.Burning]: { name: 'Quemadura', cssClass: 'debuff-burning', debuff: true },
    [Modules.Effects.Freezing]: {
        name: 'Congelamiento',
        cssClass: 'debuff-freezing',
        debuff: true
    },
    [Modules.Effects.Bleeding]: { name: 'Sangrado', cssClass: 'debuff-bleeding', debuff: true },
    [Modules.Effects.TerrorStatus]: { name: 'Terror', cssClass: 'debuff-terror', debuff: true },
    [Modules.Effects.Stun]: { name: 'Aturdimiento', cssClass: 'debuff-stun', debuff: true }
};

export default class BuffBar {
    private container: HTMLElement = document.querySelector('#buff-bar')!;
    private buffRow: HTMLElement = document.querySelector('#buff-row')!;
    private debuffRow: HTMLElement = document.querySelector('#debuff-row')!;

    private icons = new Map<Modules.Effects | string, HTMLElement>();

    public add(effect: Modules.Effects): void {
        if (this.icons.has(effect)) return;

        let info = EFFECT_MAP[effect];

        if (!info) return;

        this.addIcon(effect, info);
    }

    public remove(effect: Modules.Effects): void {
        this.removeIcon(effect);
    }

    public setPoison(active: boolean): void {
        if (active)
            this.addIcon('poison', {
                name: 'Envenenamiento',
                cssClass: 'debuff-poison',
                debuff: true
            });
        else this.removeIcon('poison');
    }

    public clear(): void {
        for (let [, icon] of this.icons) icon.remove();

        this.icons.clear();
        this.updateVisibility();
    }

    private addIcon(key: Modules.Effects | string, info: EffectInfo): void {
        if (this.icons.has(key)) return;

        let icon = document.createElement('div');
        icon.classList.add('buff-icon');
        icon.classList.add(`buff-icon-${info.cssClass}`);

        if (info.debuff) icon.classList.add('debuff');

        icon.title = info.name;

        let row = info.debuff ? this.debuffRow : this.buffRow;

        row.append(icon);
        this.icons.set(key, icon);
        this.updateVisibility();
    }

    private removeIcon(key: Modules.Effects | string): void {
        let icon = this.icons.get(key);

        if (!icon) return;

        icon.remove();
        this.icons.delete(key);
        this.updateVisibility();
    }

    private updateVisibility(): void {
        this.buffRow.style.display = this.buffRow.children.length > 0 ? 'flex' : 'none';
        this.debuffRow.style.display = this.debuffRow.children.length > 0 ? 'flex' : 'none';
        this.container.style.display = this.icons.size > 0 ? 'flex' : 'none';
    }
}
